var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-12 module-title" }, [
        _vm._v("GEPRODUCEERD")
      ]),
      _vm._v(" "),
      _vm.debug
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info" }, [
              _vm._v("\n        " + _vm._s(_vm.debug) + "\n      ")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-12" }, [
        _vm.items.length === 0 && _vm.fetchingItems.length === 0
          ? _c("div", { staticClass: "product-info" }, [
              _vm._v(
                "\n        Scan een barcode om aan te geven dat een item geproduceerd is. Je kan meerdere barcodes achter elkaar scannen.\n      "
              )
            ])
          : _c("div", { staticClass: "product-info" }, [
              _c("table", [
                _c("tr", [
                  _c("td", { staticClass: "text-left text-totals" }, [
                    _vm._v(
                      _vm._s(_vm.items.length + _vm.fetchingItems.length) +
                        " totaal"
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right text-totals" }, [
                    _vm._v(
                      _vm._s(_vm.items.length - _vm.numErrors) + " gescand"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { staticClass: "text-left text-totals" }, [
                    _vm._v(_vm._s(_vm.numScannedTwice) + " dubbel")
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right text-totals" }, [
                    _vm._v(_vm._s(_vm.numErrors) + " fouten")
                  ])
                ])
              ])
            ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-lg-12" },
        [
          _vm._l(_vm.fetchingItems, function(barcode) {
            return _c("div", { staticClass: "product-info" }, [
              _c("span", { staticClass: "item-loader float-left" }),
              _vm._v(" Verwerken " + _vm._s(barcode) + "\n      ")
            ])
          }),
          _vm._v(" "),
          _vm._l(_vm.items, function(item) {
            return _c("div", { staticClass: "product-info" }, [
              _c("table", [
                _c("tr", [
                  item.error
                    ? _c("td", [
                        _c(
                          "span",
                          {
                            staticClass:
                              "badge badge-production-status badge-error"
                          },
                          [_vm._v("Error")]
                        ),
                        _vm._v(" " + _vm._s(item.barcode))
                      ])
                    : _c("td", [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getProductionStatusBadge(item.item)
                            )
                          }
                        }),
                        _vm._v(" " + _vm._s(item.barcode))
                      ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  item.error
                    ? _c("td", [_vm._v(_vm._s(item.error))])
                    : _c("td", [
                        _vm._v(
                          _vm._s(item.item.product.productName) +
                            " " +
                            _vm._s(item.item.variation.variationName)
                        )
                      ])
                ])
              ])
            ])
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ab6b6e5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab6b6e5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScanProduced.vue
// module id = eQr8
// module chunks = 1